import React from 'react';
import './ConfirmModal.css';

interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title = 'Please Confirm',
  message,
  onCancel,
  onConfirm
}) => {
  if (!isOpen) return null;

  return (
    <div className="cm-overlay">
      <div className="cm-container">
        <div className="cm-header">
          <h2 className="cm-title">{title}</h2>
        </div>
        <div className="cm-body">
          <p>{message}</p>
        </div>
        <div className="cm-footer">
          <button className="cm-btn cm-btn--cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="cm-btn cm-btn--confirm" onClick={onConfirm}>
            Yes, delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
